<script>
import Swal from "sweetalert2";
import Room from "./main";
import locales from "../locale";
import socket from "../../../socket";
import { required, between } from "vuelidate/lib/validators";
import { chatMemberList, chatMessages } from "./data";
import { userService } from '../../../helpers/authservice/user.service';

export default {
  components: {
    Room,
  },
  props: {
    height: {
      type: String,
      default: "600px",
    },
    theme: {
      type: String,
      default: "light",
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
    responsiveBreakpoint: {
      type: Number,
      default: 900,
    },
    singleRoom: {
      type: Boolean,
      default: false,
    },
    textMessages: {
      type: Object,
      default: null,
    },
    currentUserId: {
      type: [String, Number],
      default: "",
    },

    rooms: {
      type: Array,
      default: () => [],
    },
    loadingRooms: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: null,
    },
    messages: {
      type: Array,
      default: () => [],
    },
    messagesLoaded: {
      type: Boolean,
      default: false,
    },
    textFormatting: {
      type: Boolean,
      default: true,
    },
    newMessage: {
      type: Object,
      default: null,
    },
    roomMessage: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      value: 0,
      countDownInterval: null,
      raitingModal: false,
      variant: "info",
      countdownValue: 120,
      cuntinueChatModal: false,
      actionTimeInterval: null,
      sendTimeInterval: null,
      fullname: "",
      phone: "",
      comment: "",
      rateComment: "",
      type: false,
      submitted: false,
      contactMeModal: false,
      waitingModal: false,
      waittimeInterval: null,
      usersInRoom: {},
      usersRooms: {},
      users: [],
      chatMemberList: chatMemberList,
      chatMessages: chatMessages,
      message: "",
      input: "",
      search: "",
      activetab: 2,
      emojiPickerHeight: 320,
      emojiPickerTop: 0,
      emojiPickerRight: "",
      emojiOpened: false,
      emojisList: {},
      imageDimensions: null,
      file: null,
      room: {},
      showRoomsList: false,
      isMobile: false,
    };
  },
  validations: {
    fullname: { required },
    phone: { required, between: between(500000000, 599999999) },
  },
  watch: {
    rooms(newVal, oldVal) {
      if (newVal[0] && newVal.length !== oldVal.length) {
        if (this.id) {
          const room = newVal.find((r) => r.id === this.id);
          this.fetchRoom({
            room,
          });
        } else if (!this.isMobile) {
          this.fetchRoom({
            room: this.orderedRooms[0],
          });
        } else {
          this.showRoomsList = true;
        }
      }
    },
    id: {
      immediate: true,
      handler(val) {
        if (val && !this.loadingRooms && this.rooms.length) {
          const room = this.rooms.find((r) => r.id === val);
          this.fetchRoom({
            room,
          });
        }
      },
    },
    room(val) {
      if (!val) return;
      if (Object.entries(val).length === 0) return;
    },
    newMessage(val) {
      this.$set(this.messages, val.index, val.message);
    },
  },
  created() {
    
    this.waittimeInterval = setInterval(() => {
      const time = new Date();
      const waittime =
        Math.round(time.getTime() / 1000) -
        Math.round(localStorage.getItem("startTime") / 1000);
      if (waittime > 30) {
        this.waitingModal = true;
        clearInterval(this.waittimeInterval);
      }
    }, 1000);
    const sessionID = localStorage.getItem("sessionID");
    const username = localStorage.getItem("username");
    const phone = localStorage.getItem("phone");
    console.log(sessionID)
    if (sessionID) {
      socket.auth = { sessionID };
      socket.connect();
      
    } else {
      const type = false;
      socket.auth = { username, type, phone };
      if(socket.connect()) {
              socket.emit("create customer", {
              username: this.username,
              type: false,
              phone: this.phone,
            });
      }
    }

    socket.on("session", ({ sessionID, userID }) => {
    
      // attach the session ID to the next reconnection attempts
      socket.auth = { sessionID };
      // store it in the localStorage
      localStorage.setItem("sessionID", sessionID);
      // save the ID of the user
      socket.userID = userID;
    });

    socket.on("users", (users) => {
      users.forEach((user) => {
        this.users.push(user);
      });
    });

    socket.on("end chat", () => {
      this.disconnect(1);
    });

    socket.on("rooms", (rooms) => {
      rooms.forEach((room) => {
        if (room.userID == socket.userID) {
          var roomName = socket.userID + room.operID;

          this.chatMessages = localStorage.getItem(roomName)
            ? JSON.parse(localStorage.getItem(roomName))
            : [];

          this.room = room;

          const con_user = this.filterItems(this.users, room.operID);

          con_user.forEach((user) => {
            //15.02 დამატებული
            this.waitingModal = false
            this.usersInRoom = user;
            localStorage.removeItem("startTime");
            clearInterval(this.waittimeInterval);

            //this.onSelectUser(user)
          });
          // put the current user first, and sort by username
        }
      });
      this.usersRooms = this.usersInRoom;
    });

    socket.on("private message", ({ content, from, to, time, user }) => {

      const currentDate = new Date();
      if(localStorage.getItem("info") && localStorage.getItem("info") != "false" && content=="გამარჯობა, რით შემიძლია დაგეხმაროთ?") {
      this.sendMessage({
          content: "მოკლედ აღწერა ბოტიდან:"+localStorage.getItem("info"),
          replyMessage: this.messageReply,
          time: currentDate.getHours() + ":" + currentDate.getMinutes(),
          align: "right",
          show: true,
        })
      }
      this.usersInRoom.typing = false;
      clearInterval(this.sendTimeInterval)

      this.playSound();

      if (socket.userID == to) {
        clearTimeout(this.actionTimeInterval);
        this.startActionTime();
         setTimeout(() => {
           clearTimeout(this.actionTimeInterval);
         }, 1000 * 30);
        let roomName = socket.userID + from;

        if (localStorage.getItem(roomName)) {
          let mess = JSON.parse(localStorage.getItem(roomName));
          mess.push({
            user: user,
            content,
            time: time,
            fromSelf: false,
          });
          localStorage.setItem(roomName, JSON.stringify(mess));
        } else
          localStorage.setItem(
            roomName,
            JSON.stringify([
              {
                user: user,
                content,
                time: time,
                fromSelf: false,
              },
            ])
          );
        this.chatMessages = JSON.parse(localStorage.getItem(roomName));
      }
    });

    socket.on("user disconnected", (id) => {
      for (let i = 0; i < this.users.length; i++) {
        const user = this.users[i];
        if (user.userID === id) {
          user.connected = false;
          break;
        }
      }
    });

    socket.on("user connected", (user) => {
      for (let i = 0; i < this.users.length; i++) {
        const existingUser = this.users[i];
        if (existingUser.userID === user.userID) {
          existingUser.connected = true;
          return;
        }
      }
      // initReactiveProperties(user);
      this.users.push(user);
    });

    socket.on("typing", ({ from }) => {
      if (this.usersInRoom.userID == from) {
        this.usersInRoom.typing = true;
        if (this.timeout) clearTimeout(this.timeout);
        const t = this;
        this.timeout = setTimeout(function () {
          t.usersInRoom.typing = false;
        }, 3000);
      }
    });

    this.updateResponsive();
    window.addEventListener("resize", (ev) => {
      if (ev.isTrusted) this.updateResponsive();
    });
  },
  computed: {
    t() {
      return {
        ...locales,
        ...this.textMessages,
      };
    },
    orderedRooms() {
      return this.rooms.slice().sort((a, b) => {
        const aVal = a.lastMessage || {
          date: 0,
        };
        const bVal = b.lastMessage || {
          date: 0,
        };
        return aVal.date > bVal.date ? -1 : bVal.date > aVal.date ? 1 : 0;
      });
    },
  },

  methods: {

  
    closeRateModal(){
         localStorage.removeItem("sessionID");
        localStorage.removeItem("username");
        localStorage.removeItem("phone");
      this.$router.push("/logout");
    },
    sendInterval() {
      var t  = this
      clearInterval(this.sendTimeInterval)
      this. sendTimeInterval = setTimeout(function () {
         t.disconnect(2)
        }, 1000*60*2);
    },
    playSound() {
      var audio = new Audio(require("@/assets/audio/newChat.mp3"));
      audio.play();
    },
    callback() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        const { fullname, phone, comment } = this;
        socket.emit("callback", { fullname, phone, comment });
        this.contactMeModal = false;
        Swal.fire({
          position: "center",
          icon: "success",
          title: "საკონტაქტო ინფრომაცია გაიგზავნა წარმატებით",
          showConfirmButton: false,
          timer: 2000,
        });

        localStorage.removeItem("sessionID");
        localStorage.removeItem("username");
        localStorage.removeItem("phone");
        setTimeout(() => {
          this.$router.push("/logout");
        }, 2000);
      }
    },
    stopCountDown() {
      this.countdownValue = 120;
      clearInterval(this.countDownInterval);
      this.cuntinueChatModal = false;
      this.startActionTime()
    },
    secondsToMinutes() {
      var d = Number(this.countdownValue);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);

      return "0" + m + ":" + (s < 10 ? "0" + s : s);
      //  return this.countdownValue
    },
    startActionTime() {
      this.actionTimeInterval = setTimeout(() => {
        this.countDownInterval = setInterval(() => {
          this.countdownValue -= 1;
          if (this.countdownValue < 60 && this.countdownValue >= 30)
            this.variant = "info";
          if (this.countdownValue < 30 && this.countdownValue > 0)
            this.variant = "danger";
          if (this.countdownValue < 0) {
            this.disconnect(3);
            // this.raitingModal = true
            clearInterval(this.countDownInterval);
          }
        }, 1000);

        this.cuntinueChatModal = true;
      }, 1000 * 30);
    },
    contactMe() {
      var t = 2;
      socket.emit("delete room",{t});
      // socket.disconnect()
      this.fullname = localStorage.getItem("username");
      this.phone = localStorage.getItem("phone");
      this.contactMeModal = true;
    },
    postponeWaiting() {
      this.waitingModal = false;
      const time = new Date();
      localStorage.setItem("startTime", time.getTime());
      this.waittimeInterval = setInterval(() => {
        const time = new Date();
        const waittime =
          Math.round(time.getTime() / 1000) -
          Math.round(localStorage.getItem("startTime") / 1000);
  
        if (waittime > 30) {
          this.waitingModal = true;
          clearInterval(this.waittimeInterval);
        }
      }, 1000);
    },

    filterItems(arr, query) {
      return arr.filter(function (el) {
        return el.userID === query;
      });
    },
     disconnectMenu() {
      var t = 2
   
      
      socket.emit("delete room",{t});
      socket.disconnect();
      userService.logout();
      this.raitingModal = true;
      clearTimeout(this.waittimeInterval);
      clearTimeout(this.actionTimeInterval);
      if (!this.usersRooms.userID) {
     
        this.$router.push({name:'logout'})   
      }    
      this.usersRooms.connected = false
      //this.$router.push("/logout")
    },
    disconnect(t) {
     
   
      //socket.disconnect();
      socket.emit("delete room",{t});
        socket.disconnect();
       localStorage.removeItem('user');
      this.raitingModal = true;
      clearTimeout(this.waittimeInterval);
      clearTimeout(this.actionTimeInterval);
      if (!this.usersRooms.userID) 
      {
                this.$router.push({name:'logout'})   
      }    
      this.usersRooms.connected = false
      //this.$router.push("/logout")
    },
    endChat() {
     
     window.location.href = '/login';
    },
    updateResponsive() {
      this.isMobile = window.innerWidth < this.responsiveBreakpoint;
    },
    fetchRoom({ room }) {
      this.room = room;
      this.fetchMessages({
        reset: true,
      });
      if (this.isMobile) this.showRoomsList = false;
    },
    roomInfo() {
      this.$emit("roomInfo", this.room);
    },
    fetchMessages(options) {
      this.$emit("fetchMessages", {
        room: this.room,
        options,
      });
    },
    sendMessage(message) {
      let content = message.content;
      let showMessage = message.show ?false:true;
      this.sendInterval();

      socket.emit("private message", {
        content,
        to: this.usersRooms.userID,
        roomId: this.room.roomId,
      });

      const current = new Date();

      const time =
        (current.getHours() < 10
          ? "0" + current.getHours()
          : current.getHours()) +
        ":" +
        (current.getMinutes() < 10
          ? "0" + current.getMinutes()
          : current.getMinutes()) +
        ":" +
        (current.getSeconds() < 10
          ? "0" + current.getSeconds()
          : current.getSeconds());

      let roomName = socket.userID + this.usersRooms.userID;
      if (localStorage.getItem(roomName)) {
        let mess = JSON.parse(localStorage.getItem(roomName));
        if(showMessage)
        mess.push({
          user: localStorage.getItem("username"),
          content,
          time: time,
          fromSelf: true,
          align: "right",
        });
        localStorage.setItem(roomName, JSON.stringify(mess));
      } else
      if(showMessage)
  
      localStorage.setItem(
          roomName,
          JSON.stringify([
            {
              user: localStorage.getItem("username"),
              content,
              time: time,
              fromSelf: true,
              align: "right",
            },
          ])
        );
            
        this.chatMessages = JSON.parse(localStorage.getItem(roomName));
      //  this.chatMessages.push(message);
    },
    typingMessage() {
      const to = this.usersRooms.userID;
      const from = socket.userID;
      clearTimeout(this.actionTimeInterval);
      this.actionTimeInterval = setTimeout(() => {}, 1000 * 5);
      socket.emit("typing", { from, to });
    },
  },
};
</script>

<template>
  <div class="container">
    <div class="layout-wrapper d-lg-flex">
      <div class="side-menu flex-lg-column mr-lg-1">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" tag="a" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo.png" alt height="18" />
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo.png" alt height="18" />
            </span>
          </router-link>
        </div>
        <!-- end navbar-brand-box -->

        <!-- Start side-menu nav -->

        <!-- end side-menu nav -->
      </div>

      <Room
        ref="chatContainer"
        :username="usersRooms"
        :currentUserId="currentUserId"
        :rooms="rooms"
        :id="room.id || ''"
        :messages="chatMessages"
        :roomMessage="roomMessage"
        :messagesLoaded="messagesLoaded"
        :textMessages="t"
        :singleRoom="singleRoom"
        :showRoomsList="showRoomsList"
        :textFormatting="textFormatting"
        :isMobile="isMobile"
        :loadingRooms="loadingRooms"
        :roomInfo="$listeners.roomInfo"
        @disconnect="disconnectMenu"
        @roomInfo="roomInfo"
        @fetchMessages="fetchMessages"
        @sendMessage="sendMessage"
        @typingMessage="typingMessage"
      />
    </div>

    <!-- continue waiting modal -->
    <b-modal
      no-stacking
      v-model="waitingModal"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center p-4">
        <div class="alert alert-info">ყველა კონსულტანტი დაკავებულია</div>

        <div class="mt-5">
          <ul class="list-inline mb-1">
            <li class="list-inline-item">
              <div @click="postponeWaiting" class="btn btn-outline-info">
                <i class="ri-time-line"></i> დაველოდები
              </div>
            </li>
            </ul>
        </div>
      </div>
    </b-modal>
    <!-- continue waiting modal -->

    <!-- contact me modal -->
    <b-modal
      v-model="contactMeModal"
      size="md"
      no-stacking
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="p-4">
        <h6 class="text-truncate text-center text-info imedil_h">
          დაგვიტოვე საკონტაქტო ინფორმაცია
        </h6>
        <div class="imdil_c text-dark pt-3 text-center">
          ამჟამად ყველა კონსულტანტი დაკავებულია. <br />
         სურვილის შემთხვევაში დაგვიტოვე საკონტაქტო ინფორმაცია და ჩვენ თავად დაგიკავშირდებით
        </div>
        <hr />
        <div class="mt-1">
          <form @submit.prevent="callback">
            <div class="row m-auto">
              <div class="col-12">
                <div class="form-group">
                  <label class="imedil_t">სახელი</label>
                  <div
                    class="input-group bg-soft-light input-group-lg rounded-lg"
                  >
                    <div class="input-group-prepend">
                      <span class="input-group-text border-light text-muted">
                        <i class="ri-user-line"></i>
                      </span>
                    </div>
                    <input
                      v-model="fullname"
                      type="text"
                      class="form-control bg-soft-light border-light"
                      :class="{ 'is-invalid': submitted && $v.fullname.$error }"
                      placeholder="შეიყვანე სახელი"
                    />
                    <div
                      v-if="submitted && $v.fullname.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.fullname.required"
                        >სახელი აუცილებელია</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label class="imedil_t">მობილური ტელეფონის ნომერი</label>
                  <div
                    class="
                      input-group
                      mb-3
                      bg-soft-light
                      input-group-lg
                      rounded-lg
                    "
                  >
                    <div class="input-group-prepend">
                      <span class="input-group-text border-light text-muted">
                        <i class="ri-phone-line"></i>
                      </span>
                    </div>
                    <input
                      v-model="phone"
                      type="text"
                      class="form-control bg-soft-light border-light"
                      placeholder="5XXXXXXXX"
                      :class="{ 'is-invalid': submitted && $v.phone.$error }"
                    />
                    <div
                      v-if="submitted && $v.phone.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.phone.required"
                        >ტელეფონის ნომერი აუცილებელია</span
                      >
                      <span v-if="!$v.phone.between"
                        >შეიყვანე სწორი ტელეფონის ნომერი მაგ: 5XXXXXXXX</span
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <hr />
              </div>
              <div class="col-6 m-auto">
                <button class="btn btn-info btn-block" type="submit">
                  გაგზავნა <i class="ri-send-plane-fill"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </b-modal>
    <!-- audiocall Modal -->

    <!-- continue chat modal -->
    <b-modal
      @hide="closeRateModal"
      no-stacking
      size="md"
      v-model="raitingModal"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center">
        <!-- <div><h4 class="text-info imedil_h p-1">კონსულტაციის შეფასება</h4></div> -->
  <div><h4 class="text-info imedil_h p-1">სესია დასრულდა </h4></div>
  <div><h4 class="text-info imedil_h p-1">მადლობა </h4></div>

        <!-- <div>
          <h6 class="text-black imedil_t p-2">
            მადლობა, რომ სარგებლობ ჩვენი მომსახურებით! გთხოვ შეაფასო
            მომსახურება.
          </h6>
        </div> -->
        <!-- <b-form-rating
          style="font-size: 28px"
          variant="warning"
          class="mb-2"
          v-model="value"
        ></b-form-rating>
        <textarea
          class="form-control"
          rows="5"
          v-model="rateComment"
          placeholder="მოგვწერე კომენტარი"
        ></textarea> -->
        <div class="mt-5">
          <ul class="list-inline mb-1">
            <li class="list-inline-item">
              <div class="btn btn-info" @click="endChat()">
                <i class="ri-close"></i> დასრულება
              </div>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>

    <!-- continue chat modal -->
    <b-modal
      no-stacking
      size="md"
      v-model="cuntinueChatModal"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center p-4">
        <div class="alert alert-info">
          არააქტიური სესიის გამო ონლაინ კონსულტაცია ავტომატურად დასრულდება ორ
          წუთში
        </div>
        <b-progress max="120" height="2rem">
          <b-progress-bar :value="countdownValue" :variant="variant" animated>
            <span style="font-weight: bold; font-size: 14px">{{
              secondsToMinutes()
            }}</span>
          </b-progress-bar>
        </b-progress>
        <div class="mt-5">
          <ul class="list-inline mb-1">
            <li class="list-inline-item">
              <div class="btn btn-outline-success" @click="stopCountDown()">
                <i class="ri-time-line"></i> გაგრძელება
              </div>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!-- continue waiting modal -->
  </div>
</template>

<style lang="scss">
.progress-bar {
  transition: all 1s cubic-bezier(0.5, 0.5, 0.5, 0.5);
}
.b-rating-icon svg {
  height: 2rem !important;
}
.swal2-container.swal2-center > .swal2-popup {
  font-size: 11px;
}
.swal2-title {
  font-size: 18px !important;
  font-family: "ImediFLT" !important;
}
</style>
